import { useState } from "react";

// Libraries
import { Grid, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";

// Types
import { ILot } from "@/Settings/types/administrationTools/model";

// Components
import DrawPolygon from "./DrawPolygon";
import { CircularProgress } from "@mui/material";

// Constants
import { DATE_FORMAT } from "@/Constants/date";
import DeleteLotDialog from "./DeleteLotDialog";

type TLoadItemProps = ILot & {
	removeLot: (lotKey: string) => void;
	isDeleting?: boolean;
};

export default function LotItem(props: Readonly<TLoadItemProps>) {
	const { _id: lotId, name, address, updatedAt, points, removeLot, isDeleting } = props;
	const dialogContent = "This action will remove the selected lot from the system. Do you wish to continue?";
	// States
	const [openDialog, setOpenDialog] = useState(false);

	//mutations

	const handleOpenDialog = () => {
		setOpenDialog(true);
	};
	const handleCloseDialog = () => {
		setOpenDialog(false);
	};
	const handleRemoveLot = (lotId: string) => {
		removeLot(lotId);
		setOpenDialog(false);
	};
	return (
		<Grid
			className="!p-2 !rounded-[6px] !shadow-card-gray-light"
			sx={{ position: "relative", width: "145px", minWidth: "145px", maxWidth: "145px" }}
		>
			{!isDeleting ? (
				<IconButton aria-label="close" onClick={() => handleOpenDialog()} className="!absolute !top-[1px] !right-[1px]">
					<CloseIcon sx={{ fontSize: "18px" }} />
				</IconButton>
			) : (
				<CircularProgress sx={{ color: "gray" }} size={20} className="!absolute !top-[6px] !right-[6px]" />
			)}

			<Grid item>
				<Typography className="!font-sans !font-bold !text-[14.5px] text-default" sx={{ width: "100px", maxWidth: "100px" }}>
					{name}
				</Typography>
				<Typography className="!font-sans !font-normal !text-[13px] text-default">{address}</Typography>
				<Typography className="!font-sans !font-normal !text-[13px] text-default">
					Last updated: {moment(updatedAt).format(DATE_FORMAT.usDateDash)}
				</Typography>
				<DrawPolygon points={points} _id={`${name.replaceAll(" ", "")}-${address.replaceAll(" ", "")}`} />
			</Grid>

			<DeleteLotDialog
				lotKey={lotId}
				open={openDialog}
				onClose={handleCloseDialog}
				lotName={name}
				content={dialogContent}
				removeLot={handleRemoveLot}
			/>
		</Grid>
	);
}
